import { createRoute } from "@tanstack/react-router";

import { ProtectedRoute } from "../auth/ProtectedRoute";
import { SpeedToLeadContent } from "../components/screens/SpeedToLeadContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/speed-to-lead",
  component: SpeedToLeadRoute,
});

function SpeedToLeadRoute() {
  return (
    <ProtectedRoute requiredFeatures={["speed_to_lead"]} requiredRoles={["owner"]}>
      <SpeedToLeadContent />
    </ProtectedRoute>
  );
}
